import { Datagrid, FunctionField, List, SelectInput, TextField } from 'react-admin';
import { UserLink } from '../../components/EntityLink';
import { StatusChip } from '../../components/StatusChip';
import { ResolveReportButtons } from './ReportActions';
import { formatDateTime, label, reportCategoryLabels, reportStatusLabels } from '../../i18n/labels';

const filters = [
  <SelectInput
    key="status"
    source="status"
    label="Статус жалобы"
    choices={[
      { id: 'open', name: 'Открыта' },
      { id: 'upheld', name: 'Подтверждена' },
      { id: 'dismissed', name: 'Отклонена' },
      { id: 'reviewed', name: 'Рассмотрена' },
      { id: 'all', name: 'Все' },
    ]}
    alwaysOn
  />,
];

export function ReportsList(): JSX.Element {
  return (
    <List
      filters={filters}
      filterDefaultValues={{ status: 'open' }}
      perPage={50}
      pagination={false}
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <FunctionField
          label="Категория"
          render={(record: { category: string }) => label(reportCategoryLabels, record.category)}
        />
        <FunctionField
          label="От кого"
          render={(record: { reporter: { id: string; displayName: string | null } }) => (
            <UserLink id={record.reporter.id} label={record.reporter.displayName} />
          )}
        />
        <FunctionField
          label="На кого"
          render={(record: { targetUser: { id: string; displayName: string | null } }) => (
            <UserLink id={record.targetUser.id} label={record.targetUser.displayName} />
          )}
        />
        <TextField source="targetUser.rating" label="Рейтинг" />
        <TextField source="comment" label="Комментарий" />
        <FunctionField
          label="Статус"
          render={(record: { status: string }) => (
            <StatusChip status={record.status} dict={reportStatusLabels} />
          )}
        />
        <FunctionField
          label="Создано"
          render={(record: { createdAt: string }) => formatDateTime(record.createdAt)}
        />
        <ResolveReportButtons />
      </Datagrid>
    </List>
  );
}
